export default "__VITE_ASSET__DVO3_dKK__"